import { BaseFeatureLayer } from './baseFeatureLayer';

export class BaseLocationsLayer extends BaseFeatureLayer
{
    public GetLocationIcon = (model: any, location: any, selected: boolean = false, isScenario: boolean = false) => {
        let overlay1 = '/null';
        if (selected) overlay1 = '/Selected';
        let overlay2 = '/null';
        if (location.changeType == 3) overlay2 = '/Edit';
        if (location.changeType == 2) overlay2 = '/Closing';
        if (location.changeType == 1) overlay2 = '/Opening';
        let round = '';
        if (location.type == 1 || location.type == 4 || location.type == 5) {
            if (isScenario) {
                overlay1 = '/Markers.circle_orange';
                round = 'round';
            }
            else {
                round = 'round';
            }
        }
        else {
            if (isScenario) overlay1 = '/Markers.pin_orange';
        }
        const zIndex = selected ? 21 : 20; // Higher zIndex for selected locations
        const icon: any = {
            url: '/api/models/location-groups/' + (location.locationGroupId === null ? -1 : location.locationGroupId) + '/logo/' + round + overlay1 + overlay2 + '?r=' + model.modified,
            size: 1,
            offset: -35,
            zIndex: zIndex,
        };
        if (location.type == 1) {
            icon.size = 0.5;
            icon.offset = 0;
            icon.zIndex = 17;
        } else if (location.type == 4) {
            icon.size = 0.75;
            icon.offset = 0;
            icon.zIndex = 18;
        } else if (location.type == 5) {
            icon.size = 1;
            icon.offset = 0;
            icon.zIndex = 19;
        }
        return icon
    }
}